import { render, staticRenderFns } from "./main-config.vue?vue&type=template&id=ae8d3800&"
import script from "./main-config.vue?vue&type=script&lang=js&"
export * from "./main-config.vue?vue&type=script&lang=js&"
import style0 from "./main-config.vue?vue&type=style&index=0&id=ae8d3800&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports